<template>
    <div v-if="benefits" class="mb-6 bg-a-brown-e7d7c1 p-3 rounded-14">
        <div class="pb-4 font-bold text-16 lg:text-18 text-a-brown-502314">{{lbl.tierlevel.benefit_title}}</div>
        <div v-for="(benefit, index) of benefits" :key="index"
            class="flex items-center"
            :class="[index+1 == benefits.length ? 'mb-2' : 'mb-6']">
            <img class="mr-3 w-7" :src="benefit.image_url"/>
            <div class="text-14 lg:text-16 text-a-brown-502314">{{getBenefitTxt(index)}}</div>
        </div>
    </div>
</template>
<script>
//mixins
import LocaleMixin from "@/mixin/LocaleMixin";
export default {
    name: "BenefitsList",
    mixins: [LocaleMixin],
    props: {
        benefits: Array,
    },
    methods: {
        getBenefitTxt: function(index){
            let jsonKey = 'benefit'
            if(this.localeCode == 1033){
                jsonKey = jsonKey + '_en';
            }
            return this.benefits[index][jsonKey];
        },
    },
}
</script>
